import React, { PureComponent, Fragment } from 'react';
import { array, func } from 'prop-types';
import cn from 'classnames';
import TemplateItem from './TemplateItem';

class TemplatesBlock extends PureComponent {
  state = {
    loading: true,
  };

  onImageChange = () => {
    const isLoaded = imagesLoaded(this.block);
    if (isLoaded) {
      this.setState({ loading: false }, () => {
        this.props.onLoad();
      });
    }
  };

  render() {
    const { templates, onSelect } = this.props;
    const { loading } = this.state;

    return (
      <Fragment>
        <div className={cn('row__item', { spinner: loading })}>
          <div
            className={cn('row', { hidden: loading })}
            ref={node => (this.block = node)}
          >
            {templates.map((item, key) => (
              <TemplateItem
                thumb={item.thumb}
                title={item.title}
                locale={item.locale[0]}
                onClick={() => onSelect(item)}
                onImageChange={this.onImageChange}
                key={key}
              />
            ))}
          </div>
        </div>
      </Fragment>
    );
  }
}

export default TemplatesBlock;

TemplatesBlock.propTypes = {
  templates: array.isRequired,
  onLoad: func.isRequired,
  onSelect: func.isRequired,
};

const imagesLoaded = node =>
  [...node.querySelectorAll('img')].every(({ complete }) => complete);
